Namespace 'Monitoring.Views.Dashboards.Modes'

class Monitoring.Views.Dashboards.Modes.PublicationsView extends Backbone.View

  template: JST["backbone/templates/monitoring/dashboards/modes/publications/index"]

  initialize: (@options = {}) ->
    contentsSearchQuery = @options.searchQuery
    publicationsSearchQuery = contentsSearchQuery.deepCopy()
    @activeSection = 'posts'
    if publicationsSearchQuery.get('peakpeek_selected_provider')
      @selectedProvider = publicationsSearchQuery.get('peakpeek_selected_provider')
    else
      selectedChannels = publicationsSearchQuery.get('channels')
      @selectedProvider = selectedChannels[0].provider

    @postsSectionView = new Monitoring.Views.Dashboards.Modes.Publications.PostsSectionView($.extend(@options, {
      provider: @selectedProvider,
      searchQuery: publicationsSearchQuery
    }))
    @contentsSectionView = new Monitoring.Views.Dashboards.Modes.Publications.ContentsSectionView($.extend(@options, {
      searchQuery: contentsSearchQuery
    }))
    @currentSectionView = @postsSectionView

    @contentsFilterDashboardResults = {}
    @postsFilterDashboardResults = {}

    @postsSectionView.on({
      'searchStarted': @postsSearchStarted,
      'searchCompleted': @postsSearchCompleted,
      'selectionHasChange': @disableContentsSectionTab
      'searchComments': @searchSelectedPostsComments
      'hideFilters': @hideFilters
    })
    @contentsSectionView.on({
      'searchStarted': @contentsSearchStarted,
      'searchCompleted': @contentsSearchCompleted,
      'totalChanges': @forwardEvent('totalChanges'),
      'changeSession': @forwardEvent('changeSession'),
      'restoreFromServer': @forwardEvent('restoreFromServer'),
      'onReviewCountUpdated': @forwardEvent('onReviewCountUpdated'),
      'showSocialContentsAnalysis': @forwardEvent('showSocialContentsAnalysis')
    })

  render: ->
    @$el.html(@template)
    @postsSectionView.render()
    @contentsSectionView.render()
    @postsSectionSelector().append(@postsSectionView.el)
    @contentsSectionSelector().append(@contentsSectionView.el)
    @showPostsSection()
    @disableContentsSectionTab()
    @

  newSearch: (searchQueryChanged=false, forNewMyHistorySession=false) ->
    @currentSectionView.reload()

  postsSectionSelector: ->
    @$el.find('.analysis-post-dashboard')

  contentsSectionSelector: ->
    @$el.find('.analysis-content-dashboard')

  showPostsSection: =>
    @currentSectionView = @postsSectionView
    @postsSectionSelector().show()
    @contentsSectionSelector().hide()
    # This hide Charts sub-section of contents section, cause is not in same template.
    @eventAggregator.trigger('showResultsView')

  showContentsSection: =>
    @currentSectionView = @contentsSectionView
    @contentsSectionSelector().show()
    @postsSectionSelector().hide()

  postsSearchStarted: =>
    @activeSection = 'posts'
    @showPostsSection()
    @searchStarted()

  postsSearchCompleted: (session) =>
    @searchCompletedWith(@postsSectionView.searchQuery)
    @changeDashboardSession(session)

  contentsSearchStarted: =>
    @activeSection = 'contents'
    @showContentsSection()
    @searchStarted()

  contentsSearchCompleted: =>
    @searchCompletedWith(@contentsSectionView.searchQuery)

  searchStarted: =>
    @trigger('searchStarted')

  searchCompletedWith: (searchQuery) =>
    @trigger('searchCompletedWith', searchQuery)

  changeDashboardSession: (session) =>
    @trigger('changeSession', session)

  searchSelectedPostsComments: (selectedPosts, dateFrom) =>
    @contentsSectionView.searchSelectedPostsComments(selectedPosts, dateFrom)

  createFilterView: (searchQuery, dashboardResults, topics, channels) ->
    @updateFilterDashboardResults(dashboardResults)

    new Monitoring.Views.SocialContents.Filters.PublicationsSessionFilterView({
      activeSection: @activeSection,
      selectedProvider: @selectedProvider,
      postsSection: {
        searchQuery: @postsSectionView.searchQuery,
        dashboardResults: @postsFilterDashboardResults
      },
      contentsSection: {
        searchQuery: @contentsSectionView.searchQuery,
        dashboardResults: @contentsFilterDashboardResults
      },
      topics: topics,
      sortedAvailableChannelsByProvider: channels
    })

  updateFilterDashboardResults: (dashboardResults) ->
    if @activeSection == 'contents'
      @contentsFilterDashboardResults = dashboardResults
    else
      @postsFilterDashboardResults = dashboardResults
      @postsSectionView.reloadFilters(dashboardResults)

  createChartsView: (searchQuery, dashboardResults, sessionSharingData) ->
    @contentsSectionView.createChartsView(searchQuery, dashboardResults, sessionSharingData)

  fetchNewResults: ->
    @contentsSectionView.fetchNewResults()

  # Deshabilita el tab de contenidos
  disableContentsSectionTab: =>
    @trigger('disableContentsTab')

  hideFilters: =>
    @trigger('hideFilters')

  forwardEvent: (event) =>
    (args...) => @trigger(event, args...)

  destroy: ->
    @contentsSectionView.destroy()
    @postsSectionView.destroy()
    @remove()
